import { call, put, takeLatest } from "redux-saga/effects";
import types from "./types";
import apiClientFactory from "../../backend/apiClient";
import endPoint from "../../backend/endpoints";

//get
function* getAccommodationHandlerSaga(action) {
	const apiClient = apiClientFactory();
	try {
		const { data } = yield call(
			apiClient.get,
			endPoint.dynamicList({ path: "Accommodation", ...action.payload }),
		);
		yield put({
			type: types.GET_ACCOMMODATION_SUCCESS,
			payload: data.response,
		});
	} catch (e) {
		const payload = e?.response?.data || e;
		yield put({
			type: types.GET_ACCOMMODATION_ERROR,
			payload,
		});
	}
}

export function* getAccommodationWatcherSaga() {
	yield takeLatest(types.GET_ACCOMMODATION_START, getAccommodationHandlerSaga);
}

//create

//delete

function* deleteAccommodationHandlerSaga(action) {
	const apiClient = apiClientFactory();
	try {
		const { data } = yield call(
			apiClient.delete,
			endPoint.deleteDyanamicItem("Accommodation", action.payload),
		);
		yield put({
			type: types.DELETE_ACCOMMODATION_SUCCESS,
			payload: data,
		});
	} catch (e) {
		const payload = e?.response?.data || e;
		yield put({
			type: types.DELETE_ACCOMMODATION_ERROR,
			payload,
		});
	}
}

export function* deleteAccommodationWatcherSaga() {
	yield takeLatest(
		types.DELETE_ACCOMMODATION_START,
		deleteAccommodationHandlerSaga,
	);
}

//update
